import client from "./index";

// Types
export interface Business {
  id: string;
  name: string;
  owner_id: string;
  is_owner: boolean;
  is_onboarding_complete: boolean;
}

export interface CreateBusinessRequest {
  name: string;
}

export interface UpdateBusinessRequest {
  name: string;
}

/**
 * Get all businesses the user is associated with (owned + staff)
 * Each business includes `is_owner` flag
 * Returns empty array if user has no businesses
 */
export const getMyBusinesses = async (): Promise<Business[]> => {
  const response = await client.get<Business[]>('/business');
  return response.data;
};

/**
 * Create a new business (any authenticated user)
 */
export const createBusiness = async (data: CreateBusinessRequest): Promise<Business> => {
  const response = await client.post<Business>('/business', data);
  return response.data;
};

/**
 * Update a business
 */
export const updateBusiness = async (id: string, data: UpdateBusinessRequest): Promise<Business> => {
  const response = await client.patch<Business>(`/business/${id}`, data);
  return response.data;
};

/**
 * Mark onboarding as complete for a business (owner only)
 */
export const completeOnboarding = async (businessId: string): Promise<Business> => {
  const response = await client.patch<Business>(`/business/${businessId}/onboarding-complete`);
  return response.data;
};

/**
 * Get the current user's business
 * @deprecated Use getMyBusinesses() instead - this only returns one business
 */
export const getMyBusiness = async (): Promise<Business> => {
  const response = await client.get<Business>('/business/me');
  return response.data;
};
